import React from 'react';
import ComponentRegistry from "../../Common/ComponentRegistry";
import sha1 from 'sha1';

export default class LocalStorageWidget extends React.Component {
    constructor(props) {
        super(props);

        this.store = ComponentRegistry.getStore(this.props.store);
        this.initialProductsSha = this.calculateProductSha(this.store.state.products);
    }

    componentWillMount() {
        let storedState = localStorage.getItem(this.props.name);
        let productsSha = null;
        if (storedState !== null && storedState !== undefined) {
            productsSha = this.calculateProductSha(JSON.parse(storedState).products);
        }

        if (this.initialProductsSha && (!productsSha || productsSha !== this.initialProductsSha)) {
            // There is data, but no data saved OR there is data but does not match saved data
            return;
        }

        this.store.listen(state => localStorage.setItem(this.props.name, JSON.stringify(state)));

        if (productsSha) {
            this.store.load(JSON.parse(storedState));
        }
    }

    calculateProductSha(products) {
        if (products.length === 0) {
            return null;
        }

        let skus = products.map(product => product.sku);
        return sha1(JSON.stringify(skus));
    }

    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src-js/Fratello/ProductCompare/Widgets/LocalStorageWidget.jsx